import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { IconMiscLogoDuo } from '@xingternal/malt-icon';
import { FormattedMessage } from 'react-intl';

import styles from './index.css';

const Logo = ({ className, homeLink = '/' }) => (
  <FormattedMessage id="A11Y_LOGO">
    {title => (
      <a
        href={homeLink}
        title={title}
        className={classnames(className, styles.logo)}
      >
        <IconMiscLogoDuo className={styles.icon} />
      </a>
    )}
  </FormattedMessage>
);

Logo.displayName = 'Logo';

Logo.propTypes = {
  /** add a custom className to the logo */
  homeLink: PropTypes.string,
  className: PropTypes.string,
};

export default Logo;
